import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserModel } from 'src/app/shared/models/user.model';

import { API } from '../../shared/constants/api.constants';
import { ErrorHandlingHttpClient } from 'src/app/shared/services/error-handling-http-client.service';


@Injectable({
  providedIn: 'root'
})
export class AssigneeService {
  constructor(private errorHandlingHttpClient: ErrorHandlingHttpClient) {}

  loadValues(values: string[]): Observable<UserModel[]> {
    let httpParams = new HttpParams();

    values.forEach(v => {
      httpParams = httpParams.append('usernames', v);
    });

    return this.errorHandlingHttpClient.get<UserModel[]>(`${API.searchUsersByUsernameFullMatch}`, {
      params: httpParams
    });
  }

  searchValues(query: string): Observable<UserModel[]> {
    const httpParams = (new HttpParams()).append(
      'nameBeginning', query
    );

    return this.errorHandlingHttpClient.get<UserModel[]>(`${API.getUsers}`, {
      params: httpParams
    });
  }
}
